import { DefaultTheme } from 'styled-components';

 // FUNÇÃO PARA TROCAR A COR DO TOGGLE
export const theme = (parentTheme: DefaultTheme) => ({
      ...parentTheme,
      palette: {
        // @ts-ignore
        ...parentTheme.palette,
        black : '#1e191a'
      },
      colors: {
        // @ts-ignore
        ...parentTheme.colors,
        primaryHue: 'black'
      },
      space: {
        // @ts-ignore
        ...parentTheme.space,
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
      }
  });

  export const themeRed = (parentTheme: DefaultTheme) => ({
    ...parentTheme,
    palette: {
      // @ts-ignore
      ...parentTheme.palette,
      red: '#e35b66',
    },
    colors: {
      // @ts-ignore
      ...parentTheme.colors,
      primaryHue: 'red',
    }
});

export const themeYellow = (parentTheme: DefaultTheme) => ({
  ...parentTheme,
  palette: {
    // @ts-ignore
    ...parentTheme.palette,
    yellow: '#ffc700',
  },
  colors: {
    // @ts-ignore
    ...parentTheme.colors,
    primaryHue: 'yellow',
  }
});

export const thermeBlack = (parentTheme: DefaultTheme) => ({
  ...parentTheme,
  palette: {
    // @ts-ignore
    ...parentTheme.palette,
    black: '#1e191a',
  },
  colors: {
    // @ts-ignore
    ...parentTheme.colors,
    primaryHue: 'black',
  }
});


export const themeOrange = (parentTheme: DefaultTheme) => ({
...parentTheme,
palette: {
  // @ts-ignore
  ...parentTheme.palette,
  orange: '#ed8f1c',
},
colors: {
  // @ts-ignore
  ...parentTheme.colors,
  primaryHue: 'orange',
}
});

export const themeGreen = (parentTheme: DefaultTheme) => ({
  ...parentTheme,
  palette: {
    // @ts-ignore
    ...parentTheme.palette,
    green: '#02a191',
  },
  colors: {
    // @ts-ignore
    ...parentTheme.colors,
    primaryHue: 'green',
  }
  });

export const themeGray = (parentTheme: DefaultTheme) => ({
  ...parentTheme,
  palette: {
    // @ts-ignore
    ...parentTheme.palette,
    gray: '#68737d'
  },
  colors: {
    // @ts-ignore
    ...parentTheme.colors,
    primaryHue: 'gray'
  }
})

export const themeWhite = (parentTheme: DefaultTheme) => ({
  ...parentTheme,
  palette: {
    // @ts-ignore
    ...parentTheme.palette,
    white: '#ffffff'
  },
  colors: {
    // @ts-ignore
    ...parentTheme.colors,
    primaryHue: 'white'
  }
})